import React from "react";
import { connect } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import * as authRedux from "modules/Auth/_redux/authRedux";
import * as initialRedux from "modules/Initial/_redux/initialRedux";
import AdminLayout from "markup/Layout/AdminLayout";
import MaterialTable from "material-table";
import { getUTCDate } from "helpers";
import * as adminEdnpoint from "modules/Admin/_redux/adminEndpoint";

function AdminOrders(props) {
  return (
    <AdminLayout>
      <div className="page-content bg-white">
        <MaterialTable
          title="Satışlar"
          options={{
            search: false,
            pageSize: 10,
            //toolbar: false,
          }}
          localization={{
            pagination: {
              labelDisplayedRows: "{from}-{to} / {count}",
            },
            header: {
              actions: "İşlem",
            },
            body: {
              emptyDataSourceMessage: "",
              filterRow: {
                filterTooltip: "Filtre",
              },
            },
          }}
          actions={[
            {
              icon: "storefront",
              tooltip: "Detay",
              onClick: (event, rowData) => {
                props.history.push(`/admin/orders/${rowData.id}`);
              },
            },
          ]}
          columns={[
            { title: "id", field: "ID", hidden: true },
            { title: "Sipariş No", field: "id" },
            { title: "Eklenen Bakiye", field: "acoin" },
            {
              title: "Durum",
              field: "approved",
              render: (rowData) =>
                rowData.completed ? "Tamamlandı" : "İptal Oldu",
            },
            {
              title: "Fiyat",
              field: "price",
              render: (rowData) =>
                `${
                  rowData.items[0]?.price
                    ? rowData.items[0]?.price + " TL"
                    : "Kampanya"
                }`,
            },
            {
              title: "Ödeme Şekli",
              field: "price",
              render: (rowData) =>
                rowData?.appleResponse
                  ? "Apple Ödeme"
                  : rowData?.iyzicoResponse
                  ? "Kredi Kartı"
                  : rowData?.googleResponse
                  ? "Google Ödeme"
                  : "Hediye Çeki",
            },

            {
              title: "Üye",
              field: "user",
              render: (rowData) => (
                <a
                  target="_blank"
                  href={`/admin/users/${rowData.user.id}`}
                >{`${rowData.user.name} ${rowData.user.surname}`}</a>
              ),
            },
            {
              title: "Tarih",
              field: "createdAt",
              render: (rowData) => <span>{getUTCDate(rowData.createdAt)}</span>,
            },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              adminEdnpoint
                .getOrders(query.page, query.pageSize, "desc")
                .then((res) => res.data)
                .then((result) => {
                  resolve({
                    data: result.results,
                    page: result.page - 1,
                    totalCount: result.totalResults,
                  });
                });
            })
          }
          editable={{
            isEditable: (rowData) => rowData.id,
            isDeletable: (rowData) => rowData.id,
          }}
        />
      </div>
    </AdminLayout>
  );
}

export default connect(advertRedux.reducer, {
  ...advertRedux.actions,
  ...authRedux.actions,
  ...initialRedux.actions,
})(AdminOrders);
